import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const StarOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "StarOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.8701 21.5239C17.7903 21.5239 17.7099 21.5048 17.6369 21.4661L12 18.5031L6.36314 21.4661C6.19505 21.5553 5.9897 21.541 5.83484 21.4278C5.68046 21.3156 5.60303 21.1255 5.63538 20.9373L6.71207 14.6609L2.15141 10.2159C2.01468 10.0826 1.96567 9.8831 2.02449 9.70176C2.08378 9.51995 2.24061 9.38762 2.42978 9.36018L8.73168 8.44423L11.5501 2.73386C11.7187 2.3908 12.2813 2.3908 12.4499 2.73386L15.2683 8.44423L21.5702 9.36018C21.7594 9.38762 21.9162 9.51995 21.9755 9.70176C22.0343 9.88309 21.9853 10.0825 21.8486 10.2159L17.2879 14.6609L18.3646 20.9373C18.397 21.1255 18.3195 21.3156 18.1652 21.4278C18.0779 21.4915 17.974 21.5239 17.8701 21.5239ZM12 17.4342C12.0804 17.4342 12.1603 17.4533 12.2333 17.492L17.2036 20.1046L16.2544 14.5707C16.2264 14.408 16.2803 14.2418 16.3984 14.1267L20.4195 10.2071L14.863 9.39941C14.6993 9.37588 14.5582 9.27296 14.4852 9.12496L12 4.08991L9.51484 9.12496C9.44182 9.27296 9.30067 9.37588 9.13699 9.39941L3.58051 10.2071L7.60159 14.1267C7.7197 14.2419 7.77361 14.408 7.74567 14.5707L6.79639 20.1046L11.7667 17.492C11.8398 17.4533 11.9196 17.4342 12 17.4342Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default StarOutlineIcon;
